// Dependencies
import shadows from '@mui/material/styles/shadows';

// Update shadows
shadows[1] = '0 3px 6px rgba(0, 0, 0, 0.16)';

// Export shadows
export default shadows;
